import { Component, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

import { KYMW1901Model } from './kymw1901.model';
import { KYMW1901InputModel } from './vo/kymw1901-input.model';
import { GetMembersVoiceOutputNumService } from './api-services/get-members-voice-output-num.service';
import { GetMembersVoiceOutputCSVService } from './api-services/get-members-voice-output-csv.service';

/**
 * 掲載組合員の声出力画面を管理するクラス
 *
 * @export KYMW1901Component
 * @class KYMW1901Component
 */
@Component({
  selector: 'app-kymw1901',
  templateUrl: 'kymw1901.component.html',
  styleUrls: ['kymw1901.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1901Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;
  /**
   * 画面受渡情報
   * 画面呼び出し時に受け渡されるオブジェクト
   */
  private inputVO: KYMW1901InputModel;

  /**  親画面への連携値 */
  public setKYMW1901Parameter: Function;

  /**  モデル */
  kymw1901Model: KYMW1901Model = new KYMW1901Model();

  /**
   *Creates an instance of KYMW1901Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1901Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getMembersVoiceOutputNumService: GetMembersVoiceOutputNumService,
    private getMembersVoiceOutputCSVService: GetMembersVoiceOutputCSVService,
  ) {
    super(kymw00Model);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1900InputVO
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW1901InputModel>param;
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1901Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1901';
  }

  /**
   * 出力ボタン押下時に呼び出されるメソッド。
   */
  public eventOutputHandler(): void {
    // view入力項目のチェック
    if (!this.checkViewInput()) {
      return;
    }

    // 「受注コード」の入力値を元に、出力件数を取得するための要求をサーバに送信する
    this.getMembersVoiceOutputNumService.execute(this.kymw1901Model, this.kymw1901Model.orderCode, (serverData: any) => {
      // サーバからの結果を元に、組合員の声出力件数を更新する
      this.kymw1901Model.getMembersVoiceOutputNum(serverData);
      this.eventGetMembersVoiceOutputNumCloseSuccess();
    });
  }

  /**
   * view入力項目のチェックメソッド。
   *
   * @return チェック結果
   */
  private checkViewInput(): boolean {
    // 検索条件入力チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1901Model.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return false;
    }

    return true;
  }

  /**
   * 掲載組合員の声出力データ件数取得処理成功時実行メソッド
   */
  private eventGetMembersVoiceOutputNumCloseSuccess(): void {
    // 取得した件数を元に、下記の条件で処理する
    if (this.kymw1901Model.membersVoiceOutputNum === 0) {
      // 「０件」の場合、下記のメッセージを表示し処理を終了する
      this.dialogService.openAlertGetMessage('E0100', []);
      return;
    } else {
      // 「１件以上」の場合、下記の処理を実行する

      // 「受注コード」の入力値を元に、出力情報を取得するための要求をサーバに送信する
      this.getMembersVoiceOutputCSVService.execute(this.kymw1901Model, this.kymw1901Model.orderCode, (serverData: any) => {
        this.kymw1901Model.getMembersVoiceOutputCSV(serverData);
        // ローカルファイル名の作成   掲載組合員の声データ_YYYYMMDD.CSV
        const localfile: string = '掲載組合員の声データ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.CSV';
        // ダウンロードの確認画面を起動する
        this.fileDownloadConfirmService.show(this.kymw1901Model.fileName, localfile);
      });
    }
  }

}
